import type { SearchedInvoiceReportStatus } from 'ap-openapi';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { useStatusIcon } from '../../hooks/useStatusIcon';
import styles from './StatusCell.module.scss';

const cx = classnames.bind(styles);

export type StatusCellProps = {
  status: SearchedInvoiceReportStatus;
};

export const StatusCell: FC<StatusCellProps> = memo(({ status }) => {
  const statusIcon = useStatusIcon(status);

  return (
    <div
      className={cx(
        styles['statusContainer'],
        status.key === 'rejected' && styles['bg_rejected']
      )}
    >
      <span
        className={cx(
          styles['statusIcon'],
          status.key === 'rejected' && styles['rejected'],
          status.key === 'approved' && styles['success']
        )}
      >
        {statusIcon}
      </span>
      <span
        className={cx(
          status.key === 'rejected' && styles['rejected'],
          status.key === 'canceled' && styles['canceled'],
          status.key === 'approved' && styles['success']
        )}
      >
        {status.display_name}
      </span>
    </div>
  );
});

StatusCell.displayName = 'StatusCell';
